import { render, staticRenderFns } from "./StartseiteAnmeldungenStatistik.vue?vue&type=template&id=059f2435"
import script from "./StartseiteAnmeldungenStatistik.vue?vue&type=script&lang=js"
export * from "./StartseiteAnmeldungenStatistik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports